import React from 'react';
import { EcoClub4Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub4Class2026/>;
};

export default AccountGeneralPage;